// Russian translations. Mirrors every key in i18n.uz.ts.
// User will polish these later — they're plausible but not professionally edited.

const ru: Record<string, string> = {
  // ── A11y ───────────────────────────────────────────────────────────────
  "a11y.skip_to_content": "Перейти к содержимому",
  "a11y.nav_primary": "Главная навигация",

  // ── Navigation ─────────────────────────────────────────────────────────
  "nav.home": "Главная",
  "nav.gallery": "Шаблоны",
  "nav.dashboard": "Моё приглашение",
  "nav.help": "Помощь",
  "nav.cart": "Корзина",
  "nav.signin": "Войти",
  "nav.menu": "Меню",
  "nav.signout": "Выйти",
  "nav.pricing": "Цены",

  // ── Common actions ────────────────────────────────────────────────────
  "common.save": "Сохранить",
  "common.cancel": "Отмена",
  "common.delete": "Удалить",
  "common.edit": "Редактировать",
  "common.preview": "Предпросмотр",
  "common.publish": "Опубликовать",
  "common.loading": "Загрузка...",
  "common.back": "Назад",
  "common.next": "Далее",
  "common.continue": "Продолжить",
  "common.close": "Закрыть",
  "common.open": "Открыть",
  "common.search": "Поиск",
  "common.send": "Отправить",
  "common.submit": "Отправить",
  "common.confirm": "Подтвердить",
  "common.yes": "Да",
  "common.no": "Нет",
  "common.error": "Произошла ошибка",
  "common.retry": "Повторить",
  "common.copy": "Скопировать",
  "common.copied": "Скопировано",
  "common.optional": "необязательно",
  "common.required": "обязательно",

  // ── RSVP ──────────────────────────────────────────────────────────────
  "rsvp.title": "Будем рады видеть вас.",
  "rsvp.yes": "Обязательно приду",
  "rsvp.no": "Не смогу прийти",
  "rsvp.maybe": "Пока не уверен",
  "rsvp.name": "Ваше имя",
  "rsvp.party_size": "Сколько человек придёт",
  "rsvp.message": "Сообщение (необязательно)",
  "rsvp.submit": "Отправить ответ",
  "rsvp.thanks": "Спасибо за ваш ответ",

  // ── Sharing ───────────────────────────────────────────────────────────
  "share.title": "Поделитесь с близкими",
  "share.copy": "Скопировать ссылку",
  "share.copied": "Скопировано",
  "share.telegram": "Telegram",
  "share.whatsapp": "WhatsApp",
  "share.native": "Поделиться",
  "share.qr": "QR-код",

  // ── Calendar ──────────────────────────────────────────────────────────
  "calendar.add": "Добавить в календарь",
  "calendar.download": "Скачать ICS-файл",

  // ── Music ─────────────────────────────────────────────────────────────
  "music.title": "Выберите музыку",
  "music.none": "Без музыки",
  "music.play": "Прослушать",
  "music.pause": "Пауза",
  "music.premium": "Премиум",

  // ── Editor ────────────────────────────────────────────────────────────
  "editor.title": "Редактирование приглашения",
  "editor.names": "Имена",
  "editor.date": "Дата",
  "editor.time": "Время",
  "editor.venue": "Место",
  "editor.address": "Адрес",
  "editor.map_url": "Ссылка на карту",
  "editor.story": "Наша история",
  "editor.photos": "Фотографии",
  "editor.schedule": "Программа",

  // ── Auth ──────────────────────────────────────────────────────────────
  "auth.email": "Email",
  "auth.code": "Код подтверждения",
  "auth.send_code": "Отправить код",
  "auth.verify": "Подтвердить",
  "auth.welcome": "Добро пожаловать",

  // ── Errors ────────────────────────────────────────────────────────────
  "error.network": "Проблема с подключением к интернету",
  "error.notfound": "Не найдено",
  "error.forbidden": "Доступ запрещён",

  // ── Landing hero ──────────────────────────────────────────────────────
  "landing.hero.eyebrow": "N°01 — Цифровые приглашения",
  "landing.hero.headline_1": "Каждое торжество",
  "landing.hero.headline_2": "достойно своей",
  "landing.hero.headline_3": "истории.",
  "landing.hero.body": "Современные и изысканные цифровые приглашения для свадеб, никох-туй, бешик-туй и других важных дней. За считанные минуты — память на всю жизнь.",
  "landing.hero.trust": "Каждый шаблон — авторский дизайн, созданный дизайнером",
  "landing.cta.browse": "Смотреть шаблоны →",
  "landing.cta.how": "Как это работает",
  "landing.hero.handcrafted": "handcrafted",

  // ── Landing stats ─────────────────────────────────────────────────────
  "landing.stats.templates": "шаблонов",
  "landing.stats.setup": "на оформление",
  "landing.stats.sent": "отправлено",
  "landing.stats.languages": "языка",
  "landing.stats.coming": "шаблонов в пути",
  "landing.stats.setup_value": "12 мин.",

  // ── Landing marquee ───────────────────────────────────────────────────
  "landing.marquee.wedding": "Свадьба",
  "landing.marquee.nikoh": "Никох",
  "landing.marquee.beshik": "Бешик-туй",
  "landing.marquee.birthday": "День рождения",
  "landing.marquee.jubilee": "Юбилей",
  "landing.marquee.corporate": "Корпоратив",
  "landing.marquee.memorial": "Поминки",

  // ── Landing trending (N°02) ───────────────────────────────────────────
  "landing.trending.eyebrow": "N°02 — Новинки",
  "landing.trending.headline_1": "Недавно",
  "landing.trending.headline_2": "добавленные",

  // ── Landing categories ────────────────────────────────────────────────
  "landing.categories.eyebrow": "N°03 — Шаблоны",
  "landing.categories.headline_1": "Для любого",
  "landing.categories.headline_2": "торжества",
  "landing.categories.headline_3": "—",
  "landing.categories.see_all": "Посмотреть все",

  // ── Landing featured ──────────────────────────────────────────────────
  "landing.featured.eyebrow": "N°04 · ВЫБОР",
  "landing.featured.headline_1": "Самые любимые",
  "landing.featured.headline_2": "шаблоны",
  "landing.featured.headline_3": "сезона.",

  // ── Landing how it works ──────────────────────────────────────────────
  "landing.how.eyebrow": "N°05 — Как это работает",
  "landing.how.headline_1": "Четыре шага — и",
  "landing.how.headline_2": "ваше приглашение готово.",
  "landing.how.step1.title": "Выберите",
  "landing.how.step1.desc": "Выберите подходящий вам из 240+ шаблонов.",
  "landing.how.step2.title": "Персонализируйте",
  "landing.how.step2.desc": "Измените имена, дату, адрес и текст.",
  "landing.how.step3.title": "Оплатите",
  "landing.how.step3.desc": "Оплатите через Payme, Click, Uzcard или Humo.",
  "landing.how.step4.title": "Поделитесь",
  "landing.how.step4.desc": "Отправьте гостям ссылку.",

  // ── Landing testimonial ───────────────────────────────────────────────
  "landing.testimonial.eyebrow": "N°06 — Отзывы гостей",
  "landing.testimonial.quote": "\"Самое красивое приглашение, которое идеально подошло нашей свадьбе. Наши гости даже спрашивали: «А не бумажное ли оно?» — настолько изысканно.\"",
  "landing.testimonial.location": "Ташкент · 2026",
  "landing.testimonial.ratings": "3,200+ оценок",
  "landing.testimonial.recommend": "рекомендуют",

  // ── Landing final CTA ─────────────────────────────────────────────────
  "landing.final.headline_1": "Начнём ваше",
  "landing.final.headline_2": "торжество.",
  "landing.final.body": "Выберите шаблон сегодня — и завтра порадуйте своих гостей.",

  // ── Footer ────────────────────────────────────────────────────────────
  "footer.tagline": "Самые красивые цифровые приглашения в Узбекистане. Для каждого важного момента.",
  "footer.col.discover": "Открыть",
  "footer.col.discover.all": "Все шаблоны",
  "footer.col.discover.wedding": "Свадебные приглашения",
  "footer.col.discover.nikoh": "Никох-туй",
  "footer.col.discover.birthday": "День рождения",
  "footer.col.discover.beshik": "Бешик-туй",
  "footer.col.company": "Компания",
  "footer.col.company.about": "О нас",
  "footer.col.company.designers": "Дизайнеры",
  "footer.col.company.privacy": "Конфиденциальность",
  "footer.col.company.terms": "Договор",
  "footer.col.company.contact": "Контакты",
  "footer.col.payment": "Оплата",
  "footer.copyright": "© 2026 Taklifla.uz",
  "footer.made": "Сделано с заботой в Ташкенте · ✦",
  "support.aria": "Помощь",
  "support.note": "Если есть проблема — напишите в Telegram:",
  "inapp.aria": "Уведомление о браузере",
  "inapp.body": "Некоторые функции здесь могут работать не полностью. При желании откройте сайт в обычном браузере.",
  "inapp.open_browser": "Открыть в браузере ↗",
  "inapp.copy": "Скопировать ссылку",
  "inapp.copied": "Скопировано ✓",
  "inapp.copy_fallback": "Выделите и скопируйте ссылку:",
  "inapp.ios_hint": "На iOS: нажмите ⋯ и выберите «Открыть в браузере».",
  "inapp.dismiss": "Закрыть",
  "auth.telegram.hint": "После подтверждения в Telegram вы вернётесь на сайт. Если этого не произошло — обновите эту страницу или войдите по email ниже.",
  "auth.inapp.handoff_hint": "Нажатие на Telegram откроет обычный браузер.",
  "auth.inapp.google_resume": "Нажмите кнопку Google ниже, чтобы продолжить.",
  "editor.lock.identity.pre_publish": "Внимание: имена и дату можно редактировать только 48 часов после публикации. Потом эти поля блокируются — одна покупка не сможет быть переиспользована для другой пары.",
  "editor.lock.identity.grace": "Имена и дату ещё можно редактировать — заблокируются через {remaining}.",
  "editor.lock.identity.locked": "Имена и дата заблокированы: с момента публикации прошло 48 часов. Место, расписание, музыка, заметка и прочее по-прежнему редактируются. Если действительно нужно изменить — напишите в поддержку.",
  "editor.lock.slug.pre_publish": "Внимание: после публикации URL можно менять максимум 3 раза в течение 7 дней. Потом ссылка замораживается.",
  "editor.lock.slug.remaining": "Можно изменить URL ещё {n} раз(а) в течение 7 дней после публикации.",
  "editor.lock.slug.frozen": "URL заморожен: использовано 3 изменения или прошло 7 дней с момента публикации. Ссылку больше нельзя изменить.",
  "editor.error.identity_locked": "Имена и дата заблокированы через 48 часов после публикации. Их больше нельзя редактировать.",
  "editor.error.slug_frozen": "URL заморожен и больше не редактируется.",
  "auth.already_signed_in": "Вы уже вошли в систему.",
  "auth.go_to_dashboard": "Перейти в дашборд",

  // ── Categories (template list) ────────────────────────────────────────
  "category.all": "Все",
  "category.bookie": "Bookie",
  "category.wedding": "Свадьба",
  "category.nikoh": "Никох",
  "category.birthday": "День рождения",
  "category.beshik": "Бешик той",
  "category.corporate": "Корпоратив",
  "category.memorial": "Память",
  "category.yubiley": "Юбилей",
  "category.fotixa": "Помолвка",
  "category.sunnat": "Сунат той",
  "category.graduation": "Выпускной",
  "category.uy": "Новоселье",
  "category.sevgi": "День любви",
  "category.iftor": "Ифтар",

  // ── Tier labels ───────────────────────────────────────────────────────
  "tier.bestseller": "Бестселлер",
  "tier.premium": "Премиум",
  "tier.new": "Новый",
  "tier.standard": "Стандарт",

  // ── Common (extras) ───────────────────────────────────────────────────
  "common.coming_soon": "Скоро",

  // ── Gallery ───────────────────────────────────────────────────────────
  "gallery.eyebrow": "Коллекция",
  "gallery.headline_1": "Все",
  "gallery.headline_2": "шаблоны",
  "gallery.count": "{count} шаблонов",
  "gallery.sort.popular": "Популярные",
  "gallery.sort.price_asc": "Дешёвые → Дорогие",
  "gallery.sort.price_desc": "Дорогие → Дешёвые",
  "gallery.sort.label": "Сортировка",
  "gallery.sort.newest": "Новые",
  "gallery.categories.more": "Ещё",
  "gallery.categories.allLabel": "Все категории",
  "gallery.close": "Закрыть",
  "gallery.empty": "Ничего не найдено",

  // ── Template detail ───────────────────────────────────────────────────
  "detail.device.site": "Сайт",
  "detail.device.card": "Карточка",
  "detail.device.phone": "Телефон",
  "detail.fullscreen": "Открыть на весь экран →",
  "detail.preview_caption": "Живой просмотр · прокрутите",
  "detail.premium_caption": "✦ Премиум-качество",
  "detail.description": "Полноценный сайт-приглашение. Имена, дата, место, фотогалерея, RSVP, музыка, гостевая книга — всё в одной ссылке.",
  "detail.price_caption": "Разовая оплата · неограниченные гости",
  "detail.customize": "Персонализация",
  "detail.feature.guests.title": "Без лимита гостей",
  "detail.feature.guests.caption": "Сколько угодно",
  "detail.feature.rsvp.title": "Сбор RSVP",
  "detail.feature.rsvp.caption": "Ответы и статистика",
  "detail.feature.link.title": "Личная ссылка",
  "detail.feature.link.caption": "taklifla.uz/ваше-имя",
  "detail.feature.gallery.title": "Фотогалерея",
  "detail.feature.gallery.caption": "До 10 фото",
  "detail.feature.music.title": "Музыка",
  "detail.feature.music.caption": "Фоновое звучание",
  "detail.feature.guestbook.title": "Гостевая книга",
  "detail.feature.guestbook.caption": "Поздравления от гостей",
  "detail.buy": "Продолжить · {price}",
  "detail.owned_cta": "Открыть моё приглашение",
  "detail.preparing": "Подготовка…",
  "detail.favorite": "В избранное",
  "detail.buy_error_fallback": "Ошибка при подготовке. Попробуйте ещё раз.",
  "detail.payment_methods": "Payme · Click · Uzcard · Humo · Visa · Mastercard",
  "detail.related.title_1": "Возможно",
  "detail.related.title_2": "вас заинтересует",
  "detail.related.title_3": "и это",
  "detail.related.all": "Все",

  // ── Checkout ──────────────────────────────────────────────────────────
  "checkout.breadcrumb.dashboard": "Кабинет",
  "checkout.breadcrumb.payment": "Оплата",
  "checkout.summary.eyebrow": "Детали заказа",
  "checkout.summary.title": "Ваше приглашение",
  "checkout.subtotal": "Сумма",
  "checkout.promo": "Промокод",
  "checkout.total": "Итого",
  "checkout.cancel": "← Вернуться в кабинет",
  "checkout.payment.eyebrow": "Способ оплаты",
  "checkout.payment.title": "Выберите удобный вариант",
  "checkout.payment.payme.label": "Payme",
  "checkout.payment.payme.sublabel": "Самая популярная платёжная система",
  "checkout.payment.click.label": "Click",
  "checkout.payment.click.sublabel": "Оплата картой",
  "checkout.payment.uzcard.label": "Uzcard / Visa",
  "checkout.payment.uzcard.sublabel": "Банковские карты",
  "checkout.promo.label": "Промокод",
  "checkout.promo.placeholder": "Например: TAKLIF10",
  "checkout.promo.apply": "Применить",
  "checkout.promo.unavailable": "Промокоды появятся скоро",
  "checkout.pay": "Оплатить · {total}",
  "checkout.payment_unavailable": "Платёжные системы пока не подключены — скоро",
  // Payme branding strings.
  "checkout.payWith": "Оплатить · Payme",
  "checkout.secure": "Безопасная оплата через Payme",
  "checkout.poweredBy": "ООО «Derio Technologies»",
  // Shared payment-state strings.
  "checkout.already_paid": "Это приглашение уже активировано.",
  "checkout.go_editor": "Перейти к редактору →",
  "checkout.coming_soon.title": "Платежи скоро",
  "checkout.coming_soon.body": "Интеграция с Payme/Click пока не включена в этом окружении. Пожалуйста, попробуйте позже.",
  "checkout.pay.body": "Оплатите через Payme. Сразу после подтверждения платежа приглашение активируется автоматически.",
  "checkout.pay.payme": "Оплатить через Payme · {total}",
  "checkout.pay.click": "Оплатить через Click · {total}",
  "checkout.pay.redirecting": "Перенаправление в платёжную систему…",
  "checkout.pay.disclaimer": "После подтверждения платежа приглашение активируется автоматически.",
  "checkout.pay.error_generic": "Не удалось начать оплату. Попробуйте ещё раз.",
  "payment.return.missing.title": "Нет данных о платеже",
  "payment.return.missing.body": "Идентификатор заказа не найден. Пожалуйста, начните оплату заново со страницы приглашения.",
  "payment.return.go_dashboard": "Вернуться в панель",
  "payment.return.polling.title": "Подтверждаем платёж",
  "payment.return.polling.body": "Ожидаем ответ от платёжной системы. Это займёт несколько секунд.",
  "payment.return.polling.hint": "Не закрывайте страницу.",
  "payment.return.paid.title": "Оплата прошла успешно!",
  "payment.return.paid.body": "Ваше приглашение активировано. Теперь можно его редактировать и делиться с гостями.",
  "payment.return.paid.cta_editor": "Перейти к редактору",
  "payment.return.cancelled.title": "Платёж отменён",
  "payment.return.cancelled.body": "Деньги не списаны. Вы можете повторить попытку в любой момент.",
  "payment.return.cancelled.try_again": "Повторить",
  "payment.return.failed.title": "Платёж не прошёл",
  "payment.return.failed.body": "Платёжная система отклонила транзакцию. Попробуйте другую карту или способ.",
  "payment.return.timeout.title": "Ожидание ответа",
  "payment.return.timeout.body": "Платёжная система ещё не ответила. Проверьте снова через несколько минут — если деньги списаны, приглашение активируется автоматически.",
  "payment.return.timeout.retry": "Проверить снова",
  "payment.return.error.title": "Произошла ошибка",
  "payment.return.error.not_found": "Заказ не найден.",
  "checkout.trust": "Безопасная оплата · 256-bit SSL · Payme и Click — официальные партнёры",
  "checkout.notfound.eyebrow": "Приглашение не найдено",
  "checkout.notfound.title": "Такого заказа нет",
  "checkout.notfound.body": "Проверьте ссылку или создайте новое приглашение из раздела шаблонов.",
  "checkout.notfound.cta": "Открыть шаблоны",
  "checkout.notfound.cta_dashboard": "Кабинет",
  "checkout.error.title": "Ошибка",
  "checkout.error.fallback": "Не удалось загрузить приглашение",
  "checkout.error.back": "Вернуться в кабинет",
  "checkout.promise.free": "Без лимита гостей · бессрочно",
  "checkout.promise.premium": "Бессрочно · без водяного знака · приоритетная поддержка",
  "checkout.payment.coming_soon": "Скоро",
  "checkout.breadcrumb.home": "Главная",

  // ── Detail page extras ───────────────────────────────────────────────
  "detail.breadcrumb.home": "Главная",
  "detail.breadcrumb.gallery": "Шаблоны",

  // ── Gallery page extras ──────────────────────────────────────────────
  "gallery.search.placeholder": "Поиск...",

  // ── Sections ─────────────────────────────────────────────────────────
  "sections.countdown.eyebrow": "ДО ТОРЖЕСТВА",
  "sections.countdown.day": "ДНЕЙ",
  "sections.countdown.hour": "ЧАСОВ",
  "sections.countdown.minute": "МИНУТ",
  "sections.countdown.second": "СЕКУНД",
  "sections.countdown.passed": "СОБЫТИЕ ПРОШЛО",
  "sections.schedule.eyebrow": "ПРОГРАММА",
  "sections.schedule.title": "В течение дня",
  "sections.rsvp.eyebrow": "ОТВЕТЬТЕ",
  "sections.map.eyebrow": "АДРЕС",
  "sections.map.title": "Найдите нас",
  "sections.map.open": "Открыть в Яндекс Картах →",
  "sections.map.loading": "ЗАГРУЗКА КАРТЫ…",
  "sections.gallery.eyebrow": "ФОТОАЛЬБОМ",
  "sections.gallery.title": "Наши моменты",
  "sections.guestbook.title": "Оставьте пожелание",
  "sections.guestbook.placeholder": "Напишите ваши поздравления...",
  "sections.guestbook.name_placeholder": "Ваше имя",
  "sections.guestbook.send": "Отправить →",
  "sections.guestbook.sending": "Отправляется…",
  "sections.guestbook.ok": "✓ Ваше пожелание получено",
  "sections.guestbook.err": "Не удалось отправить — попробуйте ещё раз",
  "sections.guestbook.closed.eyebrow": "КНИГА ЗАКРЫТА",
  "sections.guestbook.closed.title": "Праздник прошёл — спасибо",
  "sections.guestbook.closed.body": "Новые пожелания больше не принимаются. Слова гостей сохранятся как память об этом дне.",
  "sections.guestbook.closed.count": "{count} пожеланий оставлено",
  "sections.footer.signature": "СДЕЛАНО НА TAKLIFLA.UZ",
  "sections.lightbox.close": "Закрыть",

  // ── Dashboard ────────────────────────────────────────────────────────
  "dashboard.eyebrow": "Кабинет",
  "dashboard.greeting": "Здравствуйте, {name}",
  "dashboard.subtitle": "Ваши приглашения и их статусы здесь.",
  "dashboard.new": "Новое приглашение +",
  "dashboard.empty.title": "Пока нет приглашений",
  "dashboard.empty.body": "Чтобы создать первое приглашение, перейдите в галерею шаблонов.",
  "dashboard.empty.cta": "Открыть шаблоны →",
  "dashboard.error.eyebrow": "Ошибка",
  "dashboard.error.body": "Не удалось загрузить приглашения: {message}",
  "dashboard.error.unknown": "неизвестная ошибка",
  "dashboard.retry": "Повторить ↻",
  "dashboard.signin.title": "Моё приглашение",
  "dashboard.signin.body": "Чтобы управлять приглашениями, сначала войдите в аккаунт.",
  "dashboard.signin.cta": "Войти →",
  "dashboard.account": "Аккаунт",
  "dashboard.guest": "Гость",
  "dashboard.unnamed": "Без названия",
  "dashboard.no_date_venue": "Дата и место не указаны",
  "dashboard.status.published": "Активно",
  "dashboard.status.expired": "Истёк срок",
  "dashboard.status.draft": "Черновик",
  "dashboard.action.edit": "Редактировать",
  "dashboard.action.view": "Открыть ↗",
  "dashboard.action.publish": "Опубликовать →",
  "dashboard.action.publishing": "Публикуется…",
  "dashboard.menu.more": "Ещё",
  "dashboard.menu.publish": "Опубликовать",
  "dashboard.menu.copy_link": "Скопировать ссылку",
  "dashboard.menu.open_new": "Открыть в новой вкладке",
  "dashboard.menu.delete": "Удалить",
  "dashboard.menu.unpublish": "Скрыть приглашение",
  "dashboard.copy.copied": "✓ Скопировано",
  "dashboard.copy.action": "копировать",
  "dashboard.copy.fallback_prompt": "Скопируйте ссылку:",
  "dashboard.copy.aria": "Скопировать ссылку",
  "dashboard.confirm_delete": "Действительно удалить «{name}»?\n\nЭто действие нельзя отменить.",
  "dashboard.confirm_delete.fallback": "Это приглашение",
  "dashboard.confirm_unpublish": "Скрыть «{name}»?\n\nСсылка перестанет открываться, но приглашение и все пожелания сохранятся — вы сможете снова активировать его в любой момент.",
  "dashboard.publish.success": "Приглашение активировано! Ссылка: {url}",
  "dashboard.unpublish.success": "Приглашение скрыто. Вы можете снова активировать его в любой момент.",
  "dashboard.thumb_aria": "{name} — редактировать",
  "dashboard.thumb_fallback": "Приглашение",

  // ── Editor ───────────────────────────────────────────────────────────
  "editor.eyebrow.create": "Новое приглашение",
  "editor.eyebrow.edit": "Редактирование",
  "editor.cancel": "← Отменить",
  "editor.cancel_short": "Отменить",
  "editor.title.create_1": "Новое",
  "editor.title.create_2": "приглашение",
  "editor.title.edit_1": "Редактировать",
  "editor.title.edit_2": "приглашение",
  "editor.template_label": "Шаблон",
  "editor.status_label": "Статус",
  "editor.field.names.placeholder": "Азиза & Сардор",
  "editor.field.names.error_min": "Введите не менее 3 символов",
  "editor.field.time.placeholder": "17:00",
  "editor.field.venue.placeholder": "Ташкент",
  "editor.field.address.placeholder": "Название ресторана и полный адрес",
  "editor.field.map_url.placeholder": "https://maps.app.goo.gl/...",
  "editor.field.map_url.helper": "Необязательно. Вставьте ссылку из Google Maps, Apple Maps или Yandex — кнопка «Карта» откроет именно её.",
  "editor.field.slug.label": "Адрес (URL)",
  "editor.field.slug.placeholder": "aziza-sardor",
  "editor.field.slug.auto": "Авто",
  "editor.field.slug.error_format": "Только строчные буквы, цифры и '-'",
  "editor.field.slug.helper": "Ссылка для гостей: taklifla.uz/i/{slug}",
  "editor.field.slug.helper_empty": "...",
  "editor.field.story.label": "Наша история",
  "editor.field.story.placeholder": "Кратко о вашем знакомстве…",
  "editor.field.date.calendar": "календарь",
  "editor.field.date.text": "ввод текстом",
  "editor.field.date.placeholder": "12.06.2026",
  "editor.field.date.error": "Формат: дд.мм.гггг (например, 12.06.2026)",
  "editor.field.photos.label": "Фотографии",
  "editor.field.photos.placeholder": "Скоро — загрузка фото",
  "editor.field.music.label": "Музыка",
  "editor.field.music.placeholder": "Скоро — выбор музыки",
  "editor.field.schedule.label": "Программа",
  "editor.field.schedule.empty": "Программа пока не добавлена",
  "editor.field.schedule.event_placeholder": "Встреча гостей",
  "editor.field.schedule.delete": "Удалить",
  "editor.field.schedule.add": "+ Добавить",
  // ── Feature-driven editor blocks ─────────────────────────────────────
  "editor.feat.gallery": "Фотографии",
  "editor.feat.gallery.helper": "Загрузите 3–10 лучших фото. Первое станет главным.",
  "editor.feat.schedule": "Программа мероприятия",
  "editor.feat.agenda": "Расписание дня",
  "editor.feat.timeline": "Важные даты",
  "editor.feat.timeline.ph_a": "Год",
  "editor.feat.timeline.ph_b": "Событие",
  "editor.feat.speakers": "Спикеры",
  "editor.feat.speakers.ph_a": "Имя и фамилия",
  "editor.feat.speakers.ph_b": "Должность",
  "editor.feat.wishlist": "Список подарков",
  "editor.feat.wishlist.helper": "Идеи подарков для гостей или ссылка.",
  "editor.feat.dresscode": "Дресс-код",
  "editor.feat.dresscode.helper": "Например: классический, чёрно-белый, национальный наряд",
  "editor.feat.quran": "Аят / молитва",
  "editor.feat.quran.ph": "Введите аят или молитву для церемонии…",
  "editor.feat.bio": "Биография",
  "editor.feat.bio.ph": "Несколько слов о покойном — годы жизни, жизненный путь…",
  "editor.feat.story.love": "Ваша история любви",
  "editor.feat.story.love.ph": "Как вы познакомились, как приняли решение — короткая история…",
  "editor.feat.story.person": "О герое дня",
  "editor.feat.story.person.ph": "Несколько тёплых слов о виновнике торжества…",
  "editor.feat.story.child": "О радостном дне",
  "editor.feat.story.child.ph": "О вашем ребёнке и об этом радостном дне…",
  "editor.feat.story.memorial": "Слова памяти",
  "editor.feat.story.memorial.ph": "Воспоминания и тёплые слова о покойном…",
  "editor.feat.story.event": "О мероприятии",
  "editor.feat.story.event.ph": "Краткая информация об этом мероприятии…",
  "editor.list.add": "+ Добавить",
  "editor.list.empty": "Пока не добавлено",
  "editor.list.remove": "Удалить",
  "editor.save": "Сохранить",
  "editor.saving": "Сохранение…",
  "editor.publish": "Опубликовать →",
  "editor.publish_short": "Опубликовать",
  "editor.publishing": "Публикуется…",
  "editor.publish_disabled.not_draft": "Опубликовать можно только черновики",
  "editor.publish_disabled.fields": "Заполните все обязательные поля",
  "editor.error.save": "Ошибка при сохранении",
  "editor.error.publish": "Ошибка при публикации",
  "editor.error.names_min": "Имена должны содержать минимум 3 символа",
  "editor.error.slug_format": "Неверный формат slug. Разрешены a-z, 0-9 и '-'.",
  "editor.error.required_fields": "Перед публикацией заполните все обязательные поля",
  "editor.toast.saved": "Сохранено",
  "editor.toast.published": "Приглашение опубликовано",
  "editor.share.eyebrow": "Опубликовано · готово к отправке",
  "editor.share.title": "Ваше приглашение в эфире",
  "editor.share.body": "Отправьте эту ссылку гостям — у каждого приглашения свой уникальный адрес.",
  "editor.share.copy": "Копировать",
  "editor.share.copied": "✓ Скопировано",
  "editor.share.copy_fallback": "Выделите и скопируйте",
  "editor.share.whatsapp": "WhatsApp",
  "editor.share.telegram": "Telegram",
  "editor.share.open": "Открыть ↗",
  "editor.share.message": "Приглашаем вас на наше торжество",
  "editor.share.expires": "Активно до:",
  "editor.wishes.eyebrow": "Пожелания гостей",
  "editor.wishes.title": "Модерация пожеланий",
  "editor.wishes.body": "Все пожелания, оставленные гостями. Удаляйте те, которые показались неуместными.",
  "editor.wishes.count_suffix": "пожеланий",
  "editor.wishes.loading": "Загрузка…",
  "editor.wishes.error": "Не удалось загрузить пожелания",
  "editor.wishes.empty": "Пока пусто. Когда гость напишет, оно появится здесь.",
  "editor.wishes.delete": "Удалить",
  "editor.wishes.deleting": "Удаление…",
  "editor.wishes.confirm_delete": "Удалить это пожелание?",
  "editor.wishes.refresh": "Обновить",
  "help.eyebrow": "Центр помощи",
  "help.title_1": "Часто задаваемые",
  "help.title_2": "вопросы",
  "help.lede": "Ответы на основные вопросы по работе с Taklifla.uz. Не нашли свой? Напишите нам в Telegram — отвечаем в течение дня.",
  "help.faq.buy.q": "Как купить приглашение?",
  "help.faq.buy.a": "Выберите дизайн в разделе «Шаблоны», нажмите «Купить» и оплатите через Payme. Сразу после подтверждения платежа приглашение появится в вашем кабинете.",
  "help.faq.edit.q": "Где редактировать текст после покупки?",
  "help.faq.edit.a": "В разделе «Моё приглашение» отображается список ваших покупок. У каждого приглашения есть кнопка «Редактировать» — там меняете имена, дату, место и музыку.",
  "help.faq.share.q": "Как отправить ссылку гостям?",
  "help.faq.share.a": "После сохранения и нажатия «Опубликовать» появится панель шаринга: копировать ссылку, WhatsApp или Telegram — одной кнопкой.",
  "help.faq.expiry.q": "Сколько приглашение остаётся онлайн?",
  "help.faq.expiry.a": "После оплаты приглашение остаётся онлайн бессрочно — гости могут открыть его в любое время.",
  "help.faq.lifetime.q": "Сколько времени «живёт» купленное приглашение?",
  "help.faq.lifetime.a": "Купленное приглашение остаётся доступным, пока работает сервис taklifla.uz — возможно, на всю жизнь. Если проект будет закрыт, сайт остановлен или компания прекратит деятельность — мы не гарантируем сохранение приглашений в онлайне.",
  "help.faq.refund.q": "Можно ли вернуть деньги?",
  "help.faq.refund.a": "Автоматического возврата средств у нас нет. Если оплата была произведена по ошибке, напишите в поддержку в Telegram через @taklifla_bot — мы рассматриваем каждое обращение отдельно и постараемся помочь, если это возможно. Гарантий нет.",
  "help.contact.eyebrow": "Связаться",
  "help.contact.title": "Остался вопрос?",
  "help.contact.body": "Напишите в Telegram-бот — отвечаем в течение дня. Или отправьте email.",
  "help.contact.telegram": "Telegram",
  "help.contact.email": "Email",
  "help.contact.dashboard": "Перейти в кабинет →",
  "editor.preview.title": "Живой просмотр",
  "editor.preview.open_new": "В новой вкладке ↗",
  "editor.preview.empty": "Появится после сохранения",
  "editor.notfound.title": "Не найдено",
  "editor.notfound.body": "Это приглашение не существует или вам не принадлежит.",
  "editor.notfound.back": "← Вернуться в кабинет",
  "editor.no_template.title": "Шаблон не выбран",
  "editor.no_template.body": "Сначала выберите шаблон из галереи.",
  "editor.no_template.back": "← Вернуться в галерею",

  // ── Login ────────────────────────────────────────────────────────────
  "login.title": "Войти",
  "login.label.email": "Email",
  "login.placeholder.email": "you@email.uz",
  "login.placeholder.code": "123456",
  "login.send_code": "Отправить код",
  "login.sending": "Отправляется…",
  "login.code_sent": "Мы отправили 6-значный код на {target}.",
  "login.verify": "Подтвердить",
  "login.verifying": "Проверка…",
  "login.back": "Назад",
  "login.error.send": "Не удалось отправить",
  "login.error.code": "Неверный код",

  // Sign in with Google
  "auth.google.button": "Войти через Google",
  "auth.google.divider": "или",
  "auth.google.error.unverified": "Email этого Google-аккаунта не подтверждён.",
  "auth.google.error.failed": "Не удалось войти через Google. Попробуйте ещё раз.",
  "auth.google.error.disabled": "Вход через Google пока отключён.",

  // Sign in with Telegram — OIDC + PKCE.
  "auth.telegram.button": "Войти через Telegram",
  "auth.telegram.signing_in": "Проверка через Telegram…",
  "auth.telegram.error.title": "Ошибка входа",
  "auth.telegram.error.back_to_login": "Вернуться на страницу входа",
  "auth.telegram.error.start": "Не удалось подключиться к Telegram. Попробуйте ещё раз.",
  "auth.telegram.error.from_telegram": "Telegram вернул ошибку: {detail}",
  "auth.telegram.error.missing_code": "Telegram не вернул код. Попробуйте сначала.",
  "auth.telegram.error.no_state": "Сессия входа не найдена. Попробуйте сначала.",
  "auth.telegram.error.stale": "Сессия входа устарела. Попробуйте ещё раз.",
  "auth.telegram.error.state_mismatch": "Проверка безопасности не пройдена. Попробуйте ещё раз.",
  "auth.telegram.error.exchange": "Не удалось обменять токен Telegram. Попробуйте ещё раз.",
  "auth.telegram.error.disabled": "Вход через Telegram пока отключён.",

  "auth.verify.success": "Подтверждено",

  // ── 404 ──────────────────────────────────────────────────────────────
  "notfound.eyebrow": "Страница не найдена",
  "notfound.title": "Страница не найдена",
  "notfound.body": "Эта страница ещё не создана или была удалена. Вернитесь на главную или загляните в раздел шаблонов.",
  "notfound.home": "На главную",
  "notfound.gallery": "Открыть шаблоны",

  // ── Guest page ───────────────────────────────────────────────────────
  "guest.loading": "Загрузка…",
  "guest.notfound.title": "Приглашение не найдено",
  "guest.notfound.body": "Эта ссылка устарела или неверна.",
  "guest.error.title": "Произошла ошибка",
  "guest.cta.respond": "Ответить →",
  "guest.cta.coming": "✓ Обязательно приду",
  "guest.cta.declined": "Не смогу прийти",
  "guest.music.play_aria": "Play music",
  "guest.music.pause_aria": "Pause music",
  "guest.music.now_playing": "Now playing",
  "guest.music.tap_to_play": "Tap to play",

  // ── PhotoUploader ────────────────────────────────────────────────────
  "photo.count": "{n} / {max} фото",
  "photo.add": "+ Добавить фото",
  "photo.add_aria": "Добавить фото",
  "photo.pick_aria": "Выбрать фото",
  "photo.zone.title": "Перетащите фото или выберите",
  "photo.zone.caption": "JPG, PNG, WEBP — до 10 МБ",
  "photo.zone.slots": "Осталось мест: {n}",
  "photo.zone.aria": "Перетащите или нажмите для выбора фото",
  "photo.alt": "Фото {n}",
  "photo.delete_aria": "Удалить фото {n}",
  "photo.uploading_alt": "Загружается",
  "photo.uploading_aria": "Загружается",
  "photo.error_fallback": "Ошибка",
  "photo.retry": "Повторить",
  "photo.retry_aria": "Повторить",
  "photo.cancel_aria": "Отмена",
  "photo.error.mime": "«{name}» — принимаются только JPG, PNG или WEBP",
  "photo.error.size": "«{name}» — больше 10 МБ, загрузить нельзя",
  "photo.error.max": "Можно загрузить максимум {max} фото",
  "photo.error.network": "Сетевая ошибка",

  // ── MusicSelector ────────────────────────────────────────────────────
  "music.section_label": "Музыка",
  "music.none.subtitle": "Откроется в тишине",
  "music.loading": "Загрузка…",
  "music.fallback_notice": "Каталог временно недоступен — показан примерный список.",
  "music.preview.play_aria": "Прослушать",
  "music.preview.pause_aria": "Пауза",

  // ── RSVP section extras ──────────────────────────────────────────────
  "sections.rsvp.thanks": "Спасибо! Ваш ответ принят",
  "sections.rsvp.err": "Не удалось отправить — попробуйте ещё раз",
  "sections.rsvp.your_name": "Ваше имя",
  "sections.rsvp.deadline": "Просим ответить до {day} {month}.",
  "sections.rsvp.thanks_short": "Спасибо!",
  "sections.rsvp.guest_count": "Гостей:",
  "sections.rsvp.regret_title": "Жаль...",
  "sections.rsvp.regret_body": "Будем скучать. Спасибо за добрые пожелания.",
  "sections.rsvp.month.1": "янв",
  "sections.rsvp.month.2": "фев",
  "sections.rsvp.month.3": "мар",
  "sections.rsvp.month.4": "апр",
  "sections.rsvp.month.5": "мая",
  "sections.rsvp.month.6": "июн",
  "sections.rsvp.month.7": "июл",
  "sections.rsvp.month.8": "авг",
  "sections.rsvp.month.9": "сен",
  "sections.rsvp.month.10": "окт",
  "sections.rsvp.month.11": "ноя",
  "sections.rsvp.month.12": "дек",
  "sections.ics.suffix.wedding": " — Никох",
  "sections.ics.suffix.birthday": " — Праздник",
  "sections.ics.description.wedding": "Будем рады видеть вас на свадьбе",
  "sections.ics.description.default": "Будем рады видеть вас на торжестве",

  // ── variant.w01 (Asal — Editorial) ─────────────────────────────────────
  "variant.w01.hero.eyebrow": "ЦЕРЕМОНИЯ НИКОХ",
  "variant.w01.hero.and": "и",
  "variant.w01.hero.body": "«Приглашаем вас разделить с нами самый важный день нашей жизни.»",
  "variant.w01.hero.love_tag": "от нас, с любовью",
  "variant.w01.hero.caption_label": "ROYAL PALACE",
  "variant.w01.story.eyebrow": "наша история",
  "variant.w01.story.title": "Наша история",
  "variant.w01.story.body": "Шесть лет назад мы случайно познакомились в университетской библиотеке. В тот день мы шутили о том, как поздно возвращались домой. Сегодня же, с намерением провести вместе всю жизнь, приглашаем вас разделить с нами самый счастливый день.",
  "variant.w01.quote.text": "«Влюблённых много, но истинных — мало.»",
  "variant.w01.quote.author": "— АЛИШЕР НАВОИ",
  "variant.w01.bridal.eyebrow": "СВАДЕБНАЯ СВИТА",
  "variant.w01.bridal.title": "Те, кто рядом с нами",
  "variant.w01.bridal.groom_label": "Со стороны жениха",
  "variant.w01.bridal.groom_list": "Сардор (брат) · Бобур · Акмаль",
  "variant.w01.bridal.bride_label": "Со стороны невесты",
  "variant.w01.bridal.bride_list": "Мадина (сестра) · Нилюфар · Севара",
  "variant.w01.schedule.0.time": "16:30",
  "variant.w01.schedule.0.event": "Встреча гостей",
  "variant.w01.schedule.1.time": "17:00",
  "variant.w01.schedule.1.event": "Церемония никох",
  "variant.w01.schedule.2.time": "18:00",
  "variant.w01.schedule.2.event": "Торжественный ужин",
  "variant.w01.schedule.3.time": "20:00",
  "variant.w01.schedule.3.event": "Танцы и музыка",
  "variant.w01.schedule.4.time": "23:00",
  "variant.w01.schedule.4.event": "Финальный салют",
  "variant.w01.map.address": "Ресторан «Royal Palace» · Юнусабад, 12-й квартал",

  // ── variant.w04 (Tilla — Magazine) ─────────────────────────────────────
  "variant.w04.cover.lead": "Свадьба",
  "variant.w04.cover.featured": "ГЛАВНОЕ",
  "variant.w04.cover.exclusive": "ЭКСКЛЮЗИВНЫЙ ВЫПУСК",
  "variant.w04.cover.edition": "ВЫПУСК 01 / 99",
  "variant.w04.cover.vol": "ТОМ I · № 1",
  "variant.w04.cover.meta_date": "ДАТА",
  "variant.w04.cover.meta_time": "ВРЕМЯ",
  "variant.w04.cover.meta_venue": "МЕСТО",
  "variant.w04.spread.feature_no": "СТАТЬЯ · 04",
  "variant.w04.spread.title": "Разворот",
  "variant.w04.spread.pages": "С. 12—15",
  "variant.w04.spread.shot1": "КАДР 01",
  "variant.w04.quote.text": "Любовь — это сила, что направляет два сердца к одной цели.",
  "variant.w04.timeline.eyebrow": "НАШ ПУТЬ",
  "variant.w04.timeline.title": "Хроника любви",
  "variant.w04.timeline.chapter": "ГЛАВА",
  "variant.w04.timeline.0.event": "Знакомство",
  "variant.w04.timeline.0.sub": "Случайная встреча в университетской библиотеке",
  "variant.w04.timeline.1.event": "Первое путешествие",
  "variant.w04.timeline.1.sub": "Совместная поездка в Самарканд",
  "variant.w04.timeline.2.event": "Предложение",
  "variant.w04.timeline.2.sub": "«Да» на берегу Чарвака",
  "variant.w04.timeline.3.event": "Свадьба",
  "variant.w04.timeline.3.sub": "Сегодняшний благословенный день",
  "variant.w04.schedule.0.time": "17:00",
  "variant.w04.schedule.0.event": "Встреча гостей",
  "variant.w04.schedule.1.time": "18:00",
  "variant.w04.schedule.1.event": "Церемония никох",
  "variant.w04.schedule.2.time": "19:00",
  "variant.w04.schedule.2.event": "Galaxy Hall · Ужин",
  "variant.w04.schedule.3.time": "21:00",
  "variant.w04.schedule.3.event": "Торжественные танцы",
  "variant.w04.schedule.4.time": "23:00",
  "variant.w04.schedule.4.event": "Огненное шоу",
  "variant.w04.dress.eyebrow": "ДРЕСС-КОД",
  "variant.w04.dress.title": "Black Tie & Gold",
  "variant.w04.dress.blurb": "Вечерняя церемония — формальный наряд. Для мужчин: смокинг или тёмный костюм. Для женщин: длинное платье.",
  "variant.w04.dress.preferred_for": "РЕКОМЕНДУЕМЫЙ НАРЯД ДЛЯ {name}",
  "variant.w04.dress.swatch.0.name": "Чёрный",
  "variant.w04.dress.swatch.0.role": "Смокинг",
  "variant.w04.dress.swatch.1.name": "Золото",
  "variant.w04.dress.swatch.1.role": "Аксессуар",
  "variant.w04.dress.swatch.2.name": "Кремовый",
  "variant.w04.dress.swatch.2.role": "Рубашка",
  "variant.w04.dress.swatch.3.name": "Бордо",
  "variant.w04.dress.swatch.3.role": "Галстук",
  "variant.w04.map.address": "«Galaxy Hall» · Мирзо Улугбек, 8",
  "variant.w04.signoff": "С уважением, {first} & {second}",

  // ── variant.w03 (Bahor — PhotoLed) ─────────────────────────────────────
  "variant.w03.hero.save_the_date": "сохраните дату",
  "variant.w03.scrap.title": "Новая глава нашей жизни",
  "variant.w03.scrap.lede": "Для нас будет большой честью отметить этот день вместе с вами.",
  "variant.w03.story.eyebrow": "наша история",
  "variant.w03.story.title": "День, который нас соединил",
  "variant.w03.story.body": "Этот путь не был лёгким, но на каждом шагу мы поддерживали друг друга. Теперь мы счастливы пригласить вас на наш самый прекрасный день.",
  "variant.w03.quote.text": "«Бухара — жемчужина Великого шёлкового пути.»",
  "variant.w03.quote.eyebrow": "БУХАРА · 21.05.2026",
  "variant.w03.stamp.line1": "БУХАРА",
  "variant.w03.stamp.line2": "2026",
  "variant.w03.schedule.0.time": "16:00",
  "variant.w03.schedule.0.event": "Фотосессия",
  "variant.w03.schedule.1.time": "17:00",
  "variant.w03.schedule.1.event": "Никох",
  "variant.w03.schedule.2.time": "18:30",
  "variant.w03.schedule.2.event": "Банкет",
  "variant.w03.schedule.3.time": "21:00",
  "variant.w03.schedule.3.event": "Танцы",
  "variant.w03.map.address": "Сад «Бахор»",

  // ── variant.n01 (Nikoh Royal — Ceremonial) ─────────────────────────────
  "variant.n01.hero.eyebrow": "БИСМИЛЛЯХИР РОХМАНИР РОХИМ",
  "variant.n01.detail.0.label": "Место церемонии",
  "variant.n01.detail.1.label": "Наша махалля",
  "variant.n01.quran.eyebrow": "СВЯЩЕННЫЙ КОРАН",
  "variant.n01.quran.surah": "Сура Ар-Рум · аят 21",
  "variant.n01.quran.uzbek": "«И из Его знамений то, что Он сотворил для вас из вас самих супруг, чтобы вы находили в них покой. И установил между вами любовь и милость.»",
  "variant.n01.schedule.0.time": "10:00",
  "variant.n01.schedule.0.event": "Чтение никох",
  "variant.n01.schedule.1.time": "12:00",
  "variant.n01.schedule.1.event": "Обед",
  "variant.n01.schedule.2.time": "15:00",
  "variant.n01.schedule.2.event": "Беседа",
  "variant.n01.schedule.3.time": "17:00",
  "variant.n01.schedule.3.event": "Заключительная дуа",
  "variant.n01.map.address": "Махалля гузар",
  "variant.n01.rsvp.label": "Приглашаем вас на церемонию.",
  "variant.n01.blessing.translit": "rabbi zidnii ilman",

  // ── variant.w05 (Oqshom — Minimal) ─────────────────────────────────────
  "variant.w05.meta.label": "OQSHOM  ·  № 05",
  "variant.w05.meta.year": "MMXXVI",
  "variant.w05.meta.tagline": "город крепости",
  "variant.w05.meta.country": "УЗБЕКИСТАН",
  "variant.w05.cta.save": "СОХРАНИТЬ ДАТУ  ·  .ICS",
  "variant.w05.cta.rsvp": "ОТВЕТИТЬ",
  "variant.w05.invite.mark": "¶ I",
  "variant.w05.invite.copy": "Хотим разделить с вами самый прекрасный день нашей жизни.",
  "variant.w05.schedule.eyebrow": "¶ II  ·  ПРОГРАММА",
  "variant.w05.schedule.title_1": "Распорядок",
  "variant.w05.schedule.title_2": "дня.",
  "variant.w05.schedule.0.num": "01",
  "variant.w05.schedule.0.time": "17:00",
  "variant.w05.schedule.0.event": "Церемония никох",
  "variant.w05.schedule.1.num": "02",
  "variant.w05.schedule.1.time": "18:00",
  "variant.w05.schedule.1.event": "Ужин",
  "variant.w05.schedule.2.num": "03",
  "variant.w05.schedule.2.time": "19:30",
  "variant.w05.schedule.2.event": "Поздравления",
  "variant.w05.schedule.3.num": "04",
  "variant.w05.schedule.3.time": "20:00",
  "variant.w05.schedule.3.event": "Танцы",
  "variant.w05.colophon.title": "ВЫХОДНЫЕ ДАННЫЕ",
  "variant.w05.colophon.set_label": "ШРИФТ",
  "variant.w05.colophon.set_value": "BODONI MODA",
  "variant.w05.colophon.accent_label": "АКЦЕНТ",
  "variant.w05.colophon.accent_value": "SAGE 7A8268",
  "variant.w05.colophon.paper_label": "БУМАГА",
  "variant.w05.colophon.paper_value": "CREAM F5EFE6",
  "variant.w05.colophon.place_label": "МЕСТО",
  "variant.w05.aria.date": "Дата {date}",

  // ── variant.b02 (Confetti — Celebration) ───────────────────────────────
  "variant.b02.hero.callout": "с днём рождения",
  "variant.b02.hero.yosh": "лет!",
  "variant.b02.cta": "🎉 Приду на праздник!",
  "variant.b02.memories.eyebrow": "воспоминания",
  "variant.b02.memories.title": "Самые яркие моменты",
  "variant.b02.memories.caption.0": "именинник!",
  "variant.b02.memories.caption.1": "с друзьями",
  "variant.b02.memories.caption.2": "тортик",
  "variant.b02.cake.eyebrow": "загадай желание",
  "variant.b02.cake.title": "Диёру 7 лет!",
  "variant.b02.wishlist.eyebrow": "вишлист",
  "variant.b02.wishlist.title": "Идеи подарков",
  "variant.b02.wishlist.0.label": "Lego Star Wars",
  "variant.b02.wishlist.0.price": "220 000 сум",
  "variant.b02.wishlist.1.label": "Велосипед",
  "variant.b02.wishlist.1.price": "450 000 сум",
  "variant.b02.wishlist.2.label": "Набор книг",
  "variant.b02.wishlist.2.price": "85 000 сум",
  "variant.b02.wishlist.3.label": "Набор красок",
  "variant.b02.wishlist.3.price": "45 000 сум",
  "variant.b02.wishlist.claim": "ВЗЯТЬ",
  "variant.b02.wishlist.claimed": "✓ ВЗЯТО!",
  "variant.b02.rsvp.label": "Ждём вас на празднике!",

  // ── variant.bs01 (Beshik — Newborn) ────────────────────────────────────
  "variant.bs01.hero.welcome_stamp": "ВСТРЕЧАЙТЕ, АМИР",
  "variant.bs01.hero.script": "добро пожаловать, малыш",
  "variant.bs01.hero.alla": "«Алла, алла, родное дитя, малышка моя, алла…»",
  "variant.bs01.hero.body": "В нашей семье прибавление. Приглашаем вас на церемонию бешик-туй.",
  "variant.bs01.hero.datebox_eyebrow": "БЕШИК-ТУЙ",
  "variant.bs01.story.eyebrow": "наше благословение",
  "variant.bs01.story.title": "Новая жизнь, новая радость",
  "variant.bs01.story.body": "С приходом нашего любимого ребёнка в семью приглашаем и вас разделить эту радость. Бешик-туй — одна из самых прекрасных частей наших традиций.",
  "variant.bs01.triptych.eyebrow": "крошечные моменты",
  "variant.bs01.triptych.title": "Первые дни",
  "variant.bs01.triptych.caption.0": "первый день",
  "variant.bs01.triptych.caption.1": "месяц первый",
  "variant.bs01.triptych.caption.2": "месяц второй",
  "variant.bs01.rsvp.label": "Ждём вас на празднике.",

  // ── variant.c01 (Forum — Agenda) ───────────────────────────────────────
  "variant.c01.hero.vol": "ТОМ 01 — ЕЖЕГОДНЫЙ ВЫПУСК",
  "variant.c01.hero.label": "// 01 — ПРИГЛАШЕНИЕ",
  "variant.c01.hero.venue_suffix": "HYATT REGENCY",
  "variant.c01.hero.stat.date": "ДАТА",
  "variant.c01.hero.stat.time": "ВРЕМЯ",
  "variant.c01.hero.stat.venue": "МЕСТО",
  "variant.c01.hero.stat.dress": "ДРЕСС-КОД",
  "variant.c01.hero.stat.dress_value": "BLACK TIE",
  "variant.c01.ticker.0": "ЕЖЕГОДНЫЙ КОРПОРАТИВНЫЙ ГАЛА",
  "variant.c01.ticker.1": "ТАШКЕНТ",
  "variant.c01.ticker.2": "HYATT REGENCY",
  "variant.c01.ticker.3": "BLACK TIE",
  "variant.c01.ticker.4": "RSVP ОБЯЗАТЕЛЕН",
  "variant.c01.ticker.5": "ТОМ 01",
  "variant.c01.ticker.6": "ПРЕМИУМ",
  "variant.c01.agenda.label": "ПРОГРАММА",
  "variant.c01.agenda.head_time": "ВРЕМЯ",
  "variant.c01.agenda.head_session": "СЕССИЯ",
  "variant.c01.agenda.head_duration": "ДЛИТЕЛЬНОСТЬ",
  "variant.c01.agenda.min_suffix": "МИН",
  "variant.c01.agenda.details": "+ подробнее",
  "variant.c01.agenda.0.title": "Приветственный приём",
  "variant.c01.agenda.0.sub": "Фойе · Лёгкие закуски",
  "variant.c01.agenda.0.detail": "Коктейли и канапе в фойе Hyatt Regency. Пресс-зона расположена рядом с главным залом.",
  "variant.c01.agenda.1.title": "Открывающее выступление",
  "variant.c01.agenda.1.sub": "Главный зал · Слово CEO",
  "variant.c01.agenda.1.detail": "Итоги года и стратегические перспективы. Предусмотрены живые субтитры. Фотосъёмка — только из обозначенных зон.",
  "variant.c01.agenda.2.title": "Церемония награждения",
  "variant.c01.agenda.2.sub": "Признание выдающейся работы",
  "variant.c01.agenda.2.detail": "Вручение ежегодных наград в категориях лидерства, мастерства и командного успеха.",
  "variant.c01.agenda.3.title": "Ужин",
  "variant.c01.agenda.3.sub": "Меню из трёх блюд",
  "variant.c01.agenda.3.detail": "Авторское меню от шеф-команды Hyatt. Диетические предпочтения учитываются при RSVP.",
  "variant.c01.agenda.4.title": "Живая музыка",
  "variant.c01.agenda.4.sub": "До поздна",
  "variant.c01.agenda.4.detail": "Живое выступление и танцы. Поздний трансфер можно организовать на стойке консьержа.",
  "variant.c01.speakers.label": "СПИКЕРЫ",
  "variant.c01.speakers.0.role": "CEO",
  "variant.c01.speakers.1.role": "CMO",
  "variant.c01.speakers.2.role": "CTO",
  "variant.c01.dress.label": "ДРЕСС-КОД",
  "variant.c01.dress.title": "BLACK TIE",
  "variant.c01.dress.body": "Строгий black tie — обязательна формальная вечерняя одежда. Для джентльменов: смокинг или вечерний пиджак с галстуком-бабочкой; для дам: длинное вечернее или коктейльное платье. На входе исключений не делается.",
  "variant.c01.dress.palette_label": "РАЗРЕШЁННАЯ ПАЛИТРА",
  "variant.c01.dress.swatch.0": "ЧЁРНЫЙ",
  "variant.c01.dress.swatch.1": "БЕЛЫЙ",
  "variant.c01.dress.swatch.2": "СЛОНОВАЯ КОСТЬ",
  "variant.c01.dress.swatch.3": "ЗОЛОТОЙ АКЦЕНТ",
  "variant.c01.venue.label": "МЕСТО",
  "variant.c01.rsvp.label": "RSVP",
  "variant.c01.rsvp.confirm": "Подтвердить присутствие.",
  "variant.c01.share.label": "ПОДЕЛИТЬСЯ",
  "variant.c01.tier": "FORUM PREMIUM",
  "variant.c01.map.address": "Hyatt Regency · Конференц-зал A",

  // ── variant.m01 (Tinch — Memorial) ─────────────────────────────────────
  "variant.m01.mourning.translit": "Innaa lillaahi va innaa ilayhi rojiun",
  "variant.m01.hero.eyebrow": "В ПАМЯТЬ ОБ УШЕДШЕМ",
  "variant.m01.hero.body": "Чтя память нашего дорогого отца, дедушки и друга, приглашаем вас на поминальную церемонию. Просим прийти и помолиться вместе с нашей семьёй.",
  "variant.m01.marosim.label": "ЦЕРЕМОНИЯ",
  "variant.m01.recitation.translit": "«Innaa lillaahi va innaa ilayhi rojiun»",
  "variant.m01.recitation.meaning": "Поистине, мы принадлежим Аллаху и к Нему возвращаемся.",
  "variant.m01.dua.label": "ДУА И ПОДДЕРЖКА",
  "variant.m01.dua.line": "Прочтите дуа в память об ушедшем и окажите семье моральную поддержку.",
  "variant.m01.dua.sub": "Вместо цветов — одна Фатиха, одна молитва. Это самый ценный дар для семьи.",
  "variant.m01.ledger.label": "КНИГА ПАМЯТИ",
  "variant.m01.ledger.title": "Оставьте воспоминание",
  "variant.m01.ledger.thanks": "Спасибо за ваше воспоминание.",
  "variant.m01.ledger.name_placeholder": "Ваше имя",
  "variant.m01.ledger.line_placeholder": "Несколько слов памяти или дуа…",
  "variant.m01.ledger.submit": "ОСТАВИТЬ",
  "variant.m01.map.address": "Дом покойного",
  "variant.m01.photo_aria": "Фотография {names}",

  // ── variant.w06 (Sumalak — Botanical) ──────────────────────────────────
  "variant.w06.hero.tagline": "Весна — обновление, сумаляк — любовь. Добро пожаловать на нашу свадьбу.",
  "variant.w06.story.eyebrow": "история любви",
  "variant.w06.story.title": "Весна, начавшаяся у Регистана",
  "variant.w06.story.body": "Наши пути пересеклись в Самарканде, под золотым светом площади Регистан. В тот день, когда Гульнора засмотрелась на цветущие купола медресе Шер-Дор, Джамшид впервые увидел этот древний пейзаж по-новому — рядом с ней. Прогулки по дворам Биби-Ханым, первые лепёшки и сладости с Сиабского базара, и наш сумаляк, приготовленный вместе накануне Навруза — всё это привело нас к этому дню. Весна вернулась, деревья зацвели, и мы приглашаем вас на нашу свадьбу в город, который мы любим.",
  "variant.w06.navruz.eyebrow": "НАВРУЗ · ВЕСЕННЯЯ ТРАДИЦИЯ",
  "variant.w06.navruz.title": "Сумаляк — сладкое обещание весны",
  "variant.w06.navruz.body": "Накануне Навруза женщины проводят ночь у казана, готовя сумаляк из проросших ростков пшеницы — девяносто шесть часов весеннего обряда с деревянной мешалкой. Добрые намерения вскипают и обретают золотистый оттенок: благодать, здоровье и первая сладость новой жизни.",
  "variant.w06.navruz.proverb": "«Пусть удастся сумаляк — и счастье ваше преумножится».",
  "variant.w06.navruz.badge_0_label": "Ростки пшеницы",
  "variant.w06.navruz.badge_0_sub": "весна",
  "variant.w06.navruz.badge_1_label": "Гранат",
  "variant.w06.navruz.badge_1_sub": "свет и благодать",
  "variant.w06.navruz.badge_2_label": "Шафран",
  "variant.w06.navruz.badge_2_sub": "солнечный луч",
  "variant.w06.schedule.0.event": "Навруз-ош — раздача сумаляка",
  "variant.w06.schedule.1.event": "Церемония никох",
  "variant.w06.schedule.2.event": "Торжественный обед",
  "variant.w06.schedule.3.event": "Фотосессия у Регистана",
  "variant.w06.schedule.4.event": "Банкет и музыка",
  "variant.w06.schedule.5.event": "Танцы у костра",
  "variant.w06.map.address": "Самарканд · площадь Регистан · ресторан «Караван-Сарай»",
  "variant.w06.rsvp.label": "Добро пожаловать в весну — приглашаем на нашу свадьбу",

  // ── variant.w07 (Marvarid — Seaside) ──────────────────────────────────
  "variant.w07.hero.cta": "ОТВЕТИТЬ",
  "variant.w07.story.eyebrow": "наша история",
  "variant.w07.story.title": "История, начавшаяся на Чарваке",
  "variant.w07.story.body": "Наша первая встреча произошла на Чарвакском водохранилище — летним вечером, в лодке. Когда Лола засмотрелась на горизонт, Жасур подарил ей жемчужные серьги. С тех пор прошло два лета: чайханы, прогулки по берегу и тысячи закатов. Теперь — рядом с вами, у той же воды — пора сказать «да» навсегда.",
  "variant.w07.tide.title": "Расписание воды Чарвака",
  "variant.w07.tide.subtitle": "Парад лодок начнём в солнечные часы — пусть водная гладь станет частью церемонии.",
  "variant.w07.tide.0.label": "Восход солнца",
  "variant.w07.tide.1.label": "Высокая вода",
  "variant.w07.tide.2.label": "Парад лодок",
  "variant.w07.tide.3.label": "Закат",
  "variant.w07.schedule.0.event": "Встреча гостей · побережье",
  "variant.w07.schedule.1.event": "Церемония никох · на воде",
  "variant.w07.schedule.2.event": "Банкетный обед",
  "variant.w07.schedule.3.event": "Прогулка на лодке",
  "variant.w07.schedule.4.event": "Звёздный банкет",
  "variant.w07.schedule.5.event": "Огненное шоу",
  "variant.w07.map.address": "Чарвак · ресторан «Royal Marina» · на воде",

  // ── variant.y01 (Yubiley — Jubilee) ───────────────────────────────────
  "variant.y01.story.eyebrow": "наша история",
  "variant.y01.story.title": "Дом длиною в 25 лет",
  "variant.y01.story.body": "Двадцать пять лет назад двое отправились в путь длиною в жизнь. Мадина и Турсун вырастили троих детей, услышали смех первого внука, разделили дастархан с близкими друзьями и в самые тихие минуты не отпускали руку друг друга. Стариться вместе — и величайший дар, и величайший труд. Сегодня мы чтим четверть века этого пути и хотим разделить этот день с вами, нашими родными.",
  "variant.y01.timeline.title": "Вехи нашего пути",
  "variant.y01.timeline.0.title": "Никох",
  "variant.y01.timeline.0.body": "Свадьба Мадины и Турсуна. Стояла весна, и две семьи впервые узнали друг друга по-настоящему.",
  "variant.y01.timeline.1.title": "Первый ребёнок",
  "variant.y01.timeline.1.body": "Первые шаги в семье — родилась наша старшая дочь. Дом наполнился детским смехом.",
  "variant.y01.timeline.2.title": "Свой дом",
  "variant.y01.timeline.2.body": "После семи лет совместного труда в наших руках оказались ключи от первого собственного дома в Ташкенте.",
  "variant.y01.timeline.3.title": "Первый внук",
  "variant.y01.timeline.3.body": "Звания дедушки и бабушки. Самый долгожданный подарок жизни — наш первый внук.",
  "variant.y01.timeline.4.title": "Серебряная свадьба",
  "variant.y01.timeline.4.body": "Двадцать лет вместе. В кругу семьи мы снова сказали «да» — теперь уже вместе с детьми.",
  "variant.y01.timeline.5.title": "25-летний юбилей",
  "variant.y01.timeline.5.body": "Четверть века вместе. Сегодня мы приглашаем вас отметить эту дату с нами.",
  "variant.y01.schedule.0.event": "Встреча гостей",
  "variant.y01.schedule.1.event": "Поздравительные слова · от детей",
  "variant.y01.schedule.2.event": "Банкет",
  "variant.y01.schedule.3.event": "Первый танец · спустя 25 лет",
  "variant.y01.schedule.4.event": "Поздравления и подарки",
  "variant.y01.map.address": "Ташкент · юбилейный зал «Heritage Hall»",

  // ── variant.f01 (Fotixa — Engagement) ─────────────────────────────────
  "variant.f01.hero.eyebrow": "ФОТИХА-ТУЙ",
  "variant.f01.story.eyebrow": "наша семья",
  "variant.f01.story.title": "Две семьи за одним дастарханом",
  "variant.f01.story.body": "Сегодня две семьи объединились за одним дастарханом. Отцы — Рустам-ака и Баходыр-ака — пожали друг другу руки и открыли новую страницу жизненного пути. Матери обменялись традиционным хлебом, сладостями и платками ручной работы — эти небольшие дары стали знаком близости и уважения. Азиза и Сардор сказали друг другу своё «да»; и мы, обе семьи, приглашаем вас стать свидетелями этих священных минут.",
  "variant.f01.family.eyebrow": "ДВЕ СЕМЬИ · ОДНО ДЕРЕВО",
  "variant.f01.family.title": "Древо нашей семьи",
  "variant.f01.family.intro": "Два корня, сливаясь в один ствол, дают новые ветви. «Да», сказанное Азизой и Сардором друг другу, — это первый цветок этого дерева.",
  "variant.f01.family.groom_label": "Со стороны жениха",
  "variant.f01.family.bride_label": "Со стороны невесты",
  "variant.f01.family.groom.0.role": "Отец",
  "variant.f01.family.groom.0.name": "Рустам-ака",
  "variant.f01.family.groom.1.role": "Мать",
  "variant.f01.family.groom.1.name": "Мавлюда-опа",
  "variant.f01.family.groom.2.role": "Брат",
  "variant.f01.family.groom.2.name": "Жасур",
  "variant.f01.family.bride.0.role": "Отец",
  "variant.f01.family.bride.0.name": "Баходыр-ака",
  "variant.f01.family.bride.1.role": "Мать",
  "variant.f01.family.bride.1.name": "Мунира-опа",
  "variant.f01.family.bride.2.role": "Сестра",
  "variant.f01.family.bride.2.name": "Мадина",
  "variant.f01.schedule.0.event": "Прибытие гостей со стороны жениха",
  "variant.f01.schedule.1.event": "Торжественный вход · цветы и хлеб",
  "variant.f01.schedule.2.event": "Куйма-ош",
  "variant.f01.schedule.3.event": "Слова родителей",
  "variant.f01.schedule.4.event": "Обмен подарками",
  "variant.f01.schedule.5.event": "Заключительная дуа",
  "variant.f01.map.address": "Ташкент · дом невесты · махалля гузари",
  "variant.f01.rsvp.label": "Просим вас присоединиться к нашей семье.",

  // ── variant.sn01 (Sunnat — Celebration) ───────────────────────────────
  "variant.sn01.hero.eyebrow": "СУННАТ-ТУЙ · ПРАЗДНИК МАХАЛЛИ",
  "variant.sn01.hero.age": "{n} лет",
  "variant.sn01.dua.eyebrow": "ДУА И ДОБРЫЙ ПУТЬ",
  "variant.sn01.dua.title": "Наши пожелания Бехрузу",
  "variant.sn01.dua.intro": "Дорогие родственники и соседи махалли — в этот день мы принимаем самые добрые слова, что вы скажете нашему Бехрузу.",
  "variant.sn01.dua.0": "Милость и благословение Аллаха да будут с тобой",
  "variant.sn01.dua.1": "Живи здоровой и счастливой жизнью",
  "variant.sn01.dua.2": "Будь светом в очах родителей",
  "variant.sn01.dua.3": "Пусть путь твой всегда будет светлым",
  "variant.sn01.dua.amen": "омин",
  "variant.sn01.schedule.0.event": "Встреча гостей · чайхана",
  "variant.sn01.schedule.1.event": "Церемония суннат",
  "variant.sn01.schedule.2.event": "Куйма-плов",
  "variant.sn01.schedule.3.event": "Игры для детей",
  "variant.sn01.schedule.4.event": "Концерт и поздравления",
  "variant.sn01.schedule.5.event": "Вручение подарков",
  "variant.sn01.map.address": "Ташкент · чайхана «Бахор» · махалля гузари",
  "variant.sn01.rsvp.label": "Порадуйте нас на празднике",

  // ── variant.g01 (Bitiruv — Academia) ──────────────────────────────────
  "variant.g01.hero.eyebrow": "ВЫПУСКНАЯ ЦЕРЕМОНИЯ",
  "variant.g01.hero.institution": "UNIVERSITY OF INFORMATION TECHNOLOGIES",
  "variant.g01.story.eyebrow": "путь к знаниям",
  "variant.g01.story.title": "Четыре года труда",
  "variant.g01.story.body": "В августе 2022 года Севинч поступила на факультет компьютерной инженерии ТУИТ — направление «Программная инженерия». Четыре года она проводила вечера у компьютера, изучая алгоритмы, базы данных, машинное обучение и обработку естественного языка. На первом курсе — небольшой компилятор на C++, на втором — веб-платформа, победившая на командном хакатоне, на третьем — стажировка в IT Park. Сейчас она представляет дипломный проект — современную AI-модель для узбекского языка. Четыре года труда, тысячи строк кода, бесчисленные чашки кофе — и сегодня, в мантии и с золотой медалью в руках, Севинч произносит речь на академической выпускной церемонии.",
  "variant.g01.achievements.eyebrow": "ACADEMIC RECORD",
  "variant.g01.achievements.title": "Достижения",
  "variant.g01.achievements.0.label": "GPA 3.92 / 4.00",
  "variant.g01.achievements.0.detail": "Magna cum laude — топ 5% факультета",
  "variant.g01.achievements.1.label": "Хакатон · 2-е место",
  "variant.g01.achievements.1.detail": "TUIT × IT Park · весна 2024 года",
  "variant.g01.achievements.2.label": "Дипломный проект",
  "variant.g01.achievements.2.detail": "AI for Uzbek language — модели на основе трансформеров",
  "variant.g01.achievements.3.label": "Magna Cum Laude",
  "variant.g01.achievements.3.detail": "Академический отличник · красный диплом",
  "variant.g01.achievements.4.label": "Председатель студсовета",
  "variant.g01.achievements.4.detail": "2024 – 2026 · два срока",
  "variant.g01.schedule.0.event": "Встреча гостей · большой зал ТУИТ",
  "variant.g01.schedule.1.event": "Выпускная церемония",
  "variant.g01.schedule.2.event": "Вручение дипломов",
  "variant.g01.schedule.3.event": "Торжественный обед",
  "variant.g01.schedule.4.event": "Фотосессия",
  "variant.g01.schedule.5.event": "Выпускной ужин · в кругу семьи",
  "variant.g01.map.address": "ТУИТ · Ташкент · улица Амира Темура 108",
  "variant.g01.rsvp.label": "Порадуйте Севинч",

  // ── variant.b03 (Bayramcha — Adult Birthday) ──────────────────────────
  "variant.b03.hero.eyebrow": "30 ЛЕТ · TURNS THIRTY",
  "variant.b03.hero.age_label": "праздник тридцатилетия",
  "variant.b03.story.eyebrow": "год",
  "variant.b03.story.title": "Новое десятилетие",
  "variant.b03.story.body": "Тридцать лет — момент закрыть одно десятилетие и открыть следующее. В этот вечер хочу видеть рядом самых дорогих друзей, любимую семью и людей, ставших причиной каждой моей улыбки. Вы — моё главное богатство. Поднимем вместе бокалы и шагнём в новое десятилетие со спокойным и благодарным сердцем.",
  "variant.b03.cocktails.eyebrow": "SIGNATURE COCKTAILS",
  "variant.b03.cocktails.title": "Коктейльное меню",
  "variant.b03.cocktails.outro": "…и, конечно, настоящее шампанское — сердце вечера.",
  "variant.b03.cocktails.0.name": "Nodira's Spritz",
  "variant.b03.cocktails.0.recipe": "просекко · апероль · апельсин",
  "variant.b03.cocktails.1.name": "Charvak Sour",
  "variant.b03.cocktails.1.recipe": "виски · мёд · лимон",
  "variant.b03.cocktails.2.name": "Bahor Royale",
  "variant.b03.cocktails.2.recipe": "шампанское · груша",
  "variant.b03.schedule.0.event": "Встреча гостей",
  "variant.b03.schedule.1.event": "Открытие шампанского",
  "variant.b03.schedule.2.event": "Банкет",
  "variant.b03.schedule.3.event": "Разрезание торта",
  "variant.b03.schedule.4.event": "Танцпол",
  "variant.b03.schedule.5.event": "After-party",
  "variant.b03.map.address": "Ташкент · «Mascarpone Lounge» · улица Мустакиллик",
  "variant.b03.rsvp.label": "Ждём вас на празднике",

  // ── variant.c02 (Studio — Launch Event) ───────────────────────────────
  "variant.c02.story.title": "// about",
  "variant.c02.story.body": "Мы делаем стартап из Ташкента — and we're shipping our first real product to the world. На PRODUCT × LAUNCH мы дебютируем новую software-платформу: built in Узбекистан, designed for the region, engineered for global scale. Founders, инженеры, дизайнеры и инвесторы в одном зале — to demo what we built, to share why now, и показать, кто стоит за продуктом. Come for the live demo, stay for the panel. Code talks, hype walks. v1.0 ships tonight.",
  "variant.c02.roadmap.intro": "// what we're shipping. 0 → 1 in 12 months.",
  "variant.c02.roadmap.0.quarter": "2026 Q4",
  "variant.c02.roadmap.0.title": "Launch · v1.0",
  "variant.c02.roadmap.1.quarter": "2027 Q1",
  "variant.c02.roadmap.1.title": "Mobile apps · iOS + Android",
  "variant.c02.roadmap.2.quarter": "2027 Q2",
  "variant.c02.roadmap.2.title": "Open API",
  "variant.c02.roadmap.3.quarter": "2027 Q3",
  "variant.c02.roadmap.3.title": "Series A",
  "variant.c02.schedule.0.event": "Doors · check-in",
  "variant.c02.schedule.1.event": "Welcome talk",
  "variant.c02.schedule.2.event": "Live demo",
  "variant.c02.schedule.3.event": "Panel discussion",
  "variant.c02.schedule.4.event": "Networking",
  "variant.c02.schedule.5.event": "After-party",
  "variant.c02.map.address": "Ташкент · IT Park · конференц-зал",
  "variant.c02.hero.doors": "doors 19:00 · check-in opens",

  // ── variant.m02 (Yodgorlik — Reverent) ────────────────────────────────
  "variant.m02.hero.translit": "Innaa lillaahi va innaa ilayhi rojiun",
  "variant.m02.hero.uz_meaning": "«Поистине, мы принадлежим Аллаху и к Нему возвращаемся». С глубоким уважением приглашаем вас на поминальную церемонию нашего дорогого отца и дедушки Олима Юсупова.",
  "variant.m02.hero.marosim_label": "ЦЕРЕМОНИЯ",
  "variant.m02.story.eyebrow": "жизнь и наследие",
  "variant.m02.story.title": "Памяти Олима Юсупова",
  "variant.m02.story.body": "Олим Юсупов родился в 1942 году в Бухаре. Сорок лет своей жизни он посвятил преподаванию арабского языка и науки хадиса в медресе Мир-и-Араб — тихий, скромный, но запомнившийся каждому ученику наставник. Вместе со своей супругой Саодат-опа он вырастил троих детей и удостоился увидеть пятерых внуков. Прогулки по садам старого города, чтение Корана и наблюдение за собравшейся за дастарханом семьёй — его величайшие радости. Он покинул нас телесно, но его слова, терпение и молитва продолжают жить в каждом уголке нашего дома.",
  "variant.m02.verses.eyebrow": "АЯТЫ КОРАНА",
  "variant.m02.verses.title": "Во благо покойного",
  "variant.m02.verses.0.uzbek": "Поистине, мы принадлежим Аллаху и к Нему возвращаемся.",
  "variant.m02.verses.0.reference": "АЛЬ-БАКАРА · 2:156",
  "variant.m02.verses.1.uzbek": "Каждая душа вкусит смерть; и в День воскресения вы получите свою награду сполна.",
  "variant.m02.verses.1.reference": "АЛЬ ИМРАН · 3:185",
  "variant.m02.verses.2.uzbek": "О умиротворённая душа! Вернись к своему Господу довольной и снискавшей довольство.",
  "variant.m02.verses.2.reference": "АЛЬ-ФАДЖР · 89:27–28",
  "variant.m02.tributes.eyebrow": "СЛОВА СЕМЬИ",
  "variant.m02.tributes.title": "В памяти близких",
  "variant.m02.tributes.0.relation": "Супруга",
  "variant.m02.tributes.0.name": "Саодат-опа",
  "variant.m02.tributes.0.text": "Олим-ака — сорок лет был нашей опорой и в самые радостные, и в самые трудные дни. И в тишине, и в смехе он был фундаментом нашего дома.",
  "variant.m02.tributes.1.relation": "Сын",
  "variant.m02.tributes.1.name": "Шерзод",
  "variant.m02.tributes.1.text": "Отец был нашим главным учителем. Тот смысл, что он передавал ученикам в медресе, мы каждый день видели у себя дома.",
  "variant.m02.tributes.2.relation": "Дочь",
  "variant.m02.tributes.2.name": "Мунира",
  "variant.m02.tributes.2.text": "Отец никогда не торопился и никого не оставлял позади. Когда мы ходили вместе по улицам Бухары, он научил меня здороваться с каждым знакомым.",
  "variant.m02.tributes.3.relation": "Внучка",
  "variant.m02.tributes.3.name": "Азиза",
  "variant.m02.tributes.3.text": "Любимые книги дедушки стояли на полке рядом с ним. Теперь читаю я и будто слышу его голос.",
  "variant.m02.map.address_suffix": "Дом покойного · махалля гузари",

  // ── variant.r01 (Mehmonxona — Restaurant Opening) ─────────────────────
  "variant.r01.hero.eyebrow": "GRAND OPENING",
  "variant.r01.hero.tagline": "Новый ташкентский плов",
  "variant.r01.story.eyebrow": "открытие",
  "variant.r01.story.title": "Новый дом плова в Ташкенте",
  "variant.r01.story.body": "«Palov & Co» — это новое заведение, открывающееся в самом сердце Ташкента. Наш шеф-повар Бобур Каримов вложил двадцатилетний опыт в одну тарелку плова: отборный длиннозёрный рис, горный жир и морковь из Ферганской долины. Для нас плов — это не просто блюдо, а традиция собираться у дастархана, смех и гостеприимство. Приглашаем вас стать первыми гостями нашего нового дома.",
  "variant.r01.menu.eyebrow": "МЕНЮ · ВЕЧЕР ОТКРЫТИЯ",
  "variant.r01.menu.title": "Первый дастархан",
  "variant.r01.menu.disclaimer": "* Меню сезонное и может меняться",
  "variant.r01.menu.0.name": "Ташкентский плов",
  "variant.r01.menu.0.note": "",
  "variant.r01.menu.0.price": "65 000 сум",
  "variant.r01.menu.1.name": "Манты",
  "variant.r01.menu.1.note": "ручной лепки",
  "variant.r01.menu.1.price": "35 000 сум",
  "variant.r01.menu.2.name": "Лагман",
  "variant.r01.menu.2.note": "домашнего приготовления",
  "variant.r01.menu.2.price": "32 000 сум",
  "variant.r01.menu.3.name": "Норин",
  "variant.r01.menu.3.note": "",
  "variant.r01.menu.3.price": "28 000 сум",
  "variant.r01.menu.4.name": "Чай",
  "variant.r01.menu.4.note": "из самовара",
  "variant.r01.menu.4.price": "8 000 сум",
  "variant.r01.menu.5.name": "Халва",
  "variant.r01.menu.5.note": "домашнего приготовления",
  "variant.r01.menu.5.price": "18 000 сум",
  "variant.r01.chef.eyebrow": "ШЕФ-ПОВАР",
  "variant.r01.chef.name": "Бобур Каримов",
  "variant.r01.chef.experience": "20 лет опыта",
  "variant.r01.chef.bio": "Родился в Ферганской долине, работал в известных ресторанах Стамбула и Парижа — теперь открывает собственное заведение в Ташкенте. Его плов — это гармония традиции и современного мышления.",
  "variant.r01.schedule.0.event": "Встреча гостей · чайханный дастархан",
  "variant.r01.schedule.1.event": "Открытие ресторана · разрезание ленты",
  "variant.r01.schedule.2.event": "Меню ужина",
  "variant.r01.schedule.3.event": "Слово шеф-повара",
  "variant.r01.schedule.4.event": "Живая музыка · домбра",
  "variant.r01.schedule.5.event": "After-party",
  "variant.r01.map.address": "Ташкент · улица Мустакиллик 47 · ресторан «Palov & Co»",
  "variant.r01.rsvp.label": "Станьте нашим первым гостем",

  // ── variant.u01 (Новоселье — Housewarming) ───────────────────────────
  "variant.u01.hero.eyebrow": "НОВОСЕЛЬЕ · 2026",
  "variant.u01.hero.headline": "Семья Каримовых приглашает вас в свой новый дом",
  "variant.u01.hero.subtitle": "Перешагнём новый порог вместе — дружная семья, добрые соседи и тёплая беседа за нашим дастарханом ждут вас.",
  "variant.u01.story.eyebrow": "наш новый дом",
  "variant.u01.story.title": "Наш первый собственный дом",
  "variant.u01.story.body": "Долгожданный день настал — мы впервые переступили порог собственного дома. Стены новые, двор просторный, а двери всегда открыты. По старой традиции нашего гостеприимного народа в новый дом приходят родственники и соседи, чтобы благословить его и пожелать добра. Поэтому приглашаем вас — самых близких — стать нашими первыми гостями. Пусть наш хлеб-соль, наша теплота и наш смех будут разделены с вами.",
  "variant.u01.tour.eyebrow": "ПОКАЖЕМ НАШ ДОМ",
  "variant.u01.tour.title": "Четыре уголка нашего нового дома",
  "variant.u01.tour.subtitle": "Каждая комната — своя история. Приглашаем вас в каждую из них.",
  "variant.u01.tour.0.name": "Гостиная",
  "variant.u01.tour.0.note": "Вас ждёт большой дастархан и тёплая беседа.",
  "variant.u01.tour.1.name": "Кухня",
  "variant.u01.tour.1.note": "Мамин плов — самый родной аромат нашего дома.",
  "variant.u01.tour.2.name": "Двор",
  "variant.u01.tour.2.note": "Под тенью тутовника попьём чай и поговорим.",
  "variant.u01.tour.3.name": "Терраса",
  "variant.u01.tour.3.note": "Вечерний ветер и тихие огни города.",
  "variant.u01.gifts.eyebrow": "ЕСЛИ ПОЖЕЛАЕТЕ",
  "variant.u01.gifts.title": "Подарки на новоселье",
  "variant.u01.gifts.subtitle": "По нашей традиции в новый дом приносят полезные подарки. Подарок — не обязательство, а знак внимания.",
  "variant.u01.gifts.0.name": "Набор полотенец",
  "variant.u01.gifts.0.price": "120 000 – 180 000 сум",
  "variant.u01.gifts.1.name": "Чайный сервиз · пиалы",
  "variant.u01.gifts.1.price": "150 000 – 250 000 сум",
  "variant.u01.gifts.2.name": "Комнатное растение (пальма, монстера)",
  "variant.u01.gifts.2.price": "200 000 – 400 000 сум",
  "variant.u01.gifts.3.name": "Постельное бельё · комплект",
  "variant.u01.gifts.3.price": "180 000 – 350 000 сум",
  "variant.u01.gifts.4.name": "Набор кухонных ножей",
  "variant.u01.gifts.4.price": "250 000 – 500 000 сум",
  "variant.u01.gifts.disclaimer": "* Лучший подарок — ваши добрые пожелания и смех.",
  "variant.u01.schedule.0.event": "Встреча гостей · чай и сладости",
  "variant.u01.schedule.1.event": "Открытие дастархана · плов",
  "variant.u01.schedule.2.event": "Осмотр нового дома · экскурсия по комнатам",
  "variant.u01.schedule.3.event": "Музыка и танцы · семейные беседы",
  "variant.u01.schedule.4.event": "Прощальная молитва · слово старейшин",
  "variant.u01.map.address": "Ташкент · Юнусабадский район · махалля Каримовых · дом 14",
  "variant.u01.rsvp.label": "Приходите в наш новый дом",

  // ── Legal pages ───────────────────────────────────────────────────────
  "legal.updated": "Обновлено",
  "legal.privacy.title": "Политика конфиденциальности",
  "legal.privacy.h.collect": "Какие данные мы собираем",
  "legal.privacy.collect": "Мы собираем минимум данных, необходимых для создания и доставки приглашений:",
  "legal.privacy.collect.phone": "Email для входа в учётную запись.",
  "legal.privacy.collect.event": "Детали события, которые вы вводите (имена, дата, место, фотографии, музыка).",
  "legal.privacy.collect.guests": "Когда гости подтверждают участие — имя, статус ответа, число гостей и опциональный комментарий.",
  "legal.privacy.h.use": "Как мы используем данные",
  "legal.privacy.use": "Ваши данные используются только для отображения приглашения, сбора ответов гостей и связи с вами при необходимости. Мы не продаём данные третьим лицам.",
  "legal.privacy.h.tracking": "Отслеживание и аналитика",
  "legal.privacy.tracking": "taklifla.uz не использует сторонние трекеры и аналитику (нет Google Analytics, Facebook Pixel и т. п.). Только наши собственные журналы работы.",
  "legal.privacy.h.retention": "Срок хранения",
  "legal.privacy.retention": "Приглашения и ответы гостей хранятся всё время существования вашего аккаунта. При удалении аккаунта все связанные данные удаляются в течение 30 дней.",
  "legal.privacy.h.contact": "Контакты",
  "legal.privacy.contact": "По вопросам конфиденциальности пишите:",

  "legal.terms.title": "Условия использования",
  "legal.terms.h.service": "О сервисе",
  "legal.terms.service": "taklifla.uz — платформа для создания и публикации цифровых приглашений. Созданные приглашения отправляются по ссылке выбранным гостям.",
  "legal.terms.h.tiers": "Оплата",
  "legal.terms.tiers": "Все шаблоны платные. Каждый шаблон оплачивается разово — после оплаты приглашение доступно бессрочно. Доступность купленного приглашения сохраняется, пока работает сервис taklifla.uz — возможно, на всю жизнь. Если проект будет закрыт, сайт остановлен или компания прекратит деятельность, мы не гарантируем сохранение приглашения в онлайне.",
  "legal.terms.h.refund": "Возврат средств",
  "legal.terms.refund": "Автоматический возврат средств не предусмотрен. Если считаете, что оплата была произведена по ошибке, опишите ситуацию в поддержку в Telegram через @taklifla_bot — каждое обращение рассматривается индивидуально. Возврат не гарантируется.",
  "legal.terms.h.responsibilities": "Ответственность пользователя",
  "legal.terms.responsibilities": "Вы подтверждаете, что весь контент в приглашении (имена, адреса, фотографии) законен и принадлежит вам.",
  "legal.terms.h.contact": "Контакты",
  "legal.terms.contact": "По вопросам условий пишите:",

  "doc.title": "taklifla.uz — красивые цифровые приглашения",
};

export default ru;
